var version = {
    "name":      "dativery",
    "buildDateCode": "20260915-140146",
    "buildDate": "Tue Sep 15 2026 14:01:46 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260915-140146",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;